<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <lv-material-date [meldung]="uiArtefakt.UIMeldung"
                      [placeholder]="'TT.MM.JJJJ'" #dateToolbox="ngModel"
                      [ngModel]="model" class="lv-date-input"
                      (ngModelChange)="changeDate($event)"
                      (blurEvent)="onBlur($event)"
                      [textForRequiredError]="uiArtefakt.FehlertextPflichtfeld"
                      [errorPath]="'ERRORS.DATUM.'" [outerErrors]="dateToolbox?.errors"
                      [required]="uiArtefakt.PflichtfeldJN" [isTouched]="dateToolbox?.touched"
                      [isDirty]="dateToolbox?.dirty" [name]="uiArtefakt.Identifikator"
                      [disabled]="isDisabled" [autocomplete]="autocomplete">
    </lv-material-date>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
